import {uniqueId} from 'lodash'

const inputs = [
  {
    label: 'Subject',
    model: 'name',
    autofocus: true,
    required: true
  },
  {
    label: 'Client',
    type: 'select',
    options: [],
    listLabel: 'nickName',
    model: 'client',
    searchable: true,
    required: true,
    getValue: (value = {}) => value._id,
    searchableBy: 'nickName'
  },
  {
    label: 'Project manager',
    type: 'select',
    options: [],
    listLabel: 'username',
    model: 'projectManager',
    isType: true
  },
  {
    label: 'Comment',
    type: 'textareaEditor',
    model: 'commentText',
    height: '140px',
    placeholder: 'Enter text...',
    alignItem: 'start',
    options: [],
    isAddUser: true,
    autofocus: true,
    required: true
  },
  {
    label: 'Cost, AED',
    format: 'number',
    model: 'amount',
    required: true
  },
  {
    label: 'Date',
    type: 'date',
    format: 'DD, MMMM YYYY',
    model: 'dateStart',
    required: true,
    grid: {
      gridTemplateColumns: '174px 175px',
      alignItem: 'center',
      gridGap: '10px'
    }
  },
  {
    label: 'Tags',
    type: 'selectTag',
    model: 'tags',
    options: [],
    grid: {
      gridTemplateColumns: '174px 1fr',
      alignItem: 'center',
      gridGap: '10px'
    }
  }
]

const gridTemplate = (alignItem) => {
  return {
    gridTemplateColumns: '174px minmax(301px, auto)',
    alignItems: alignItem || 'center',
    gridGap: '10px'
  }
}

const prefix = 'input_request_'
const requestInputs = inputs.map(item => {
  item.id = uniqueId(prefix)
  if (!item.grid) item.grid = gridTemplate(item.alignItem)
  return item
})

export default requestInputs



// WEBPACK FOOTER //
// ./src/constants/InputsSettings/requestInputs.js